<template>
    <div>

        <!-- Modal Component -->
        <b-modal 
            ref="docModal"
            title="Modificar documento"
            :ok-disabled="enviando || !modalNombre(indexDoc) || !modalDescripcion(indexDoc)"
            :cancel-disabled="enviando"
            @ok="modificaDocumento(indexDoc)"
            ok-title="Guardar"
            cancel-title="Cancelar">
            
            <label for="docName">Nombre:</label>
            <b-form-input 
                id="docName"
                v-model.trim="modal.nombre"
                type="text"
                :state="modalNombre(indexDoc)"
                :disabled="enviando"
                aria-describedby="inputLiveFeedback"
                placeholder="Ingrese un nombre">
            </b-form-input>


            <label for="docDesc">Descripción:</label>
            <b-form-textarea id="docDesc"
                v-model="modal.descripcion"
                placeholder="Ingrese descripción"
                aria-describedby="textLiveFeedback"
                :state="modalDescripcion(indexDoc)"
                :disabled="enviando"
                :rows="3"
                :max-rows="6">
            </b-form-textarea>

            <label v-if="enviando" class="pull-right"><i>Guardando datos...</i></label>
        </b-modal>

        <ul class="list-unstyled">
            <p v-if="docs.length === 0"><i>No se han cargado documentos...</i></p>
            
            <draggable :list="docs" @update="moverDocumento" :options="{handle:'.handle'}">
                <div v-for="(element, index) in docs" :key="index">
                <b-media 
                    tag="li"
                    style="padding: 5px;">
                    
                    <!-- Imagen del documento -->
                    <b-img :src="'/img/'+getIcon(element.path)" slot="aside" width="40" height="50" alt="docImage" />
                    
                    <!-- Editar y eliminar -->
                    <b-button-group v-if="puedeModificarDoc" size="sm" class="pull-right">
                        <b-button 
                            size="sm" 
                            :variant="element.visible ? 'outline-success' : 'outline-secondary'"
                            @click="cambiaVisible(element._id)">
                            <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                        </b-button>
                        <b-button class="handle"
                            variant="outline-secondary"
                            v-b-tooltip.hover title="Mover de posición">
                            <i class="fa fa-arrows-alt fa-lg"></i>
                        </b-button>
                        <b-button 
                            variant="outline-secondary"
                            @click="modificaDocModal(index)"
                            v-b-tooltip.hover title="Modificar documento">
                            <i class="fa fa-pencil fa-lg"></i>
                        </b-button>
                        <b-button 
                            variant="outline-secondary"
                            @click="eliminaDocumento(element._id,index)"
                            v-b-tooltip.hover title="Eliminar documento">
                            <i class="fa fa-trash fa-lg"></i>
                        </b-button>
                    </b-button-group>

                    <!-- Nombre y descripción del documento -->
                    <b-form-checkbox-group id="checkboxes" name="flavour2" v-model="eliminaVarios">
                        <h5 class="mt-0 mb-1">
                            <b-form-checkbox :value="element._id">
                                {{element.nombre}}
                            </b-form-checkbox>
                        </h5>
                        {{element.descripcion}}
                        <br>
                    </b-form-checkbox-group>

                    <!-- Detalles del documento -->
                    <small>Tamaño: {{getTamanio(element.size)}}.&nbsp;&nbsp;&nbsp; 
                        Tipo: {{element.tipo}} &nbsp;&nbsp;&nbsp; 
                        Publicación: {{getFecha(element.publicacion)}}
                    </small>

                    <!-- Descargar / Previsualizar -->
                    <b-button-group size="sm" class="pull-right">
                        <b-button
                            variant="outline-primary"
                            @click="copiarRuta(element.path)"
                            v-b-tooltip.hover
                            title="Copiar link de descarga"
                            size="sm"
                            >
                            <i class="fa fa-paperclip fa-lg"></i>
                        </b-button>
                        <b-button 
                            variant="outline-primary"
                            size="sm"
                            :href="httpURL+'/'+element.path"
                            >
                            <i class="fa fa-download"></i> Descargar
                        </b-button>
                        <b-button 
                            variant="outline-primary"
                            size="sm"
                            :href="'https://docs.google.com/viewer?url='+httpURL+'/'+docs[index].path+'&embedded=true'"
                            target="_blank">
                            <i class="fa fa-search"></i> Previsualizar
                        </b-button>
                    </b-button-group> 

                </b-media>
                </div>
            </draggable>
            
            <b-button-group>
                <b-button v-if="puedeModificarDoc && docs.length > 0"
                    variant="primary"
                    @click="descargarVarios()"
                    v-b-tooltip.hover
                    title="Descargar seleccionados"
                    size="sm"
                    :disabled="eliminaVarios.length > 0 ? false : true">
                    <i class="fa fa-download fa-lg"></i>
                </b-button>
                <b-button v-if="puedeModificarDoc && docs.length > 0"
                    variant="primary"
                    @click="eliminarVarios()"
                    v-b-tooltip.hover
                    title="Eliminar seleccionados"
                    size="sm"
                    :disabled="eliminaVarios.length > 0 ? false : true">
                    <i class="fa fa-trash fa-lg"></i>
                </b-button>
            </b-button-group>
                &nbsp; 

            <b-form-checkbox v-if="puedeModificarDoc && docs.length > 0" v-model="allSelected"
                @change="seleccionarTodos"
                >Seleccionar todos
            </b-form-checkbox>

        </ul>

        <!-- Área de copiado -->
        <input type="hidden" id="copyzone" ref="copyzone" />
        
        <!-- Dropzone -->
        <div v-if="puedeAgregarDoc" class="dropzone">
            <input 
                type="file" 
                multiple
                class="input-file"
                @change="subirArchivos" />
            <p>Para agregar archivos arrástrelos a esta zona.</p>
        </div>

        <!-- Documentos subiendo -->
        <sube-doc 
            v-for="(element, index) in uploading" :key="index"
            :file="element"
            :tipoItem="tipoItem"
            @eliminaDocumento="uploading.splice(index,1)"
            @documentoCargado="agregaDocumento"
        />


    </div>
</template>

<script>
import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import SubeDoc from './SubeDoc';
const date = require('date-and-time');

import draggable from 'vuedraggable'

export default {
    name: 'ItemDocs',
    components: {
        Loader,
        SubeDoc,
        draggable
    },
    props: ["docs","tipoItem","seccion"],
    computed: {
        ...mapGetters([
        "httpURL",
        "sessionToken",
        "permisos",
        "role"
        ]),
        puedeAgregarDoc(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 114) >= 0 )
                return true;
            else
                return false;
        },
        puedeModificarDoc(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 115) >= 0 )
                return true;
            else
                return false;
        }
    },
    data: function () {
        return {
            enviando: false,
            id: this.$route.params.id,
            uploading: [],
            indexDoc: 0,
            modal: {
                nombre:'',
                descripcion: '',
                _id: null
            },
            preview: {
                title: '',
                document: null
            },
            eliminaVarios: [],
            allSelected: false,
            copyPath: ""
        }
    },
    watch: {
        '$route'(to, from) {
            this.id = to.params.id;
        }
    },
    methods: {
        subirArchivos(event){
            let files = event.target.files;
            for( let i=0; i<files.length; i++){
                this.uploading.push(files[i]);
            }
        },
        agregaDocumento(documento){
            this.docs.push(documento);
        },
        modificaDocModal(index){
            this.indexDoc = index;
            this.modal._id = this.docs[index]._id;
            this.modal.nombre = this.docs[index].nombre;
            this.modal.descripcion = this.docs[index].descripcion ? this.docs[index].descripcion: '';
            this.$refs.docModal.show();
        },
        modalNombre(index){
            //if(this.docs[index].nombre.length < 5)
            if(this.modal.nombre.length < 5)
                return false;
            else
                return true;
        },
        modalDescripcion(index){
            //if(this.docs[index].descripcion.length < 5)
            if(this.modal.descripcion.length < 5)
                return false;
            else
                return true;
        },
        modificaDocumento(){
            this.$emit('enviandoStart');
            let id = this.modal._id;
            axios.put(this.httpURL+'/transparencia/normatividad/documento/'+id,
                {nombre: this.modal.nombre,
                descripcion: this.modal.descripcion},
                {headers:{token:this.sessionToken}})
                .then(res => {
                    this.docs[this.indexDoc].nombre = this.modal.nombre;
                    this.docs[this.indexDoc].descripcion = this.modal.descripcion;
                    this.$refs.docModal.hide();
                    this.modal = {
                        nombre: '',
                        descripcion: '',
                        disabled: false,
                        index: null
                    };
                    this.$emit('enviandoStop');
                })
                .catch(error => {
                    if(error.response){
                        swal("Oops!",error.response.data.mensaje , "error")
                    }else if( error.request){
                        swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                    }
                    this.$emit('enviandoStop');
                });
        },
        eliminaDocumento(idDoc,index){
            swal({
                    icon: 'info',
                    title: 'Área protegida',
                    text: 'Esta acción requiere de tu contraseña:',
                    content: {
                    element: "input",
                    attributes: {
                    placeholder: "Ingrese...",
                    type: "password",
                }
                },
                    closeOnClickOutside: true,
                    button: {
                    text: "Confirmar",
                    closeModal: false,
                },
            })
            .then(password => {
                if (!password){
                    swal.close();
                }else{
                    this.enviando = true;
                    axios.delete(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/'+idDoc,
                            {data:{password},headers: {token:this.sessionToken}})
                        .then(res => {
                            swal.close();
                            this.docs.splice(index,1);
                            this.$emit('enviandoStop');
                        })
                        .catch(error => {
                            //console.log(error);
                            this.$emit('enviandoStop');
                            swal("Error",'Contraseña incorrecta', "error");
                        });
                }
            });
        },

        seleccionarTodos(checked){
            this.eliminaVarios = [];
            if( checked ){
                this.docs.forEach(element => {
                    this.eliminaVarios.push(element._id);
                });
            }
        },

        eliminarVarios(){
            swal({
                    icon: 'info',
                    title: 'Área protegida',
                    text: 'Esta acción requiere de tu contraseña:',
                    content: {
                    element: "input",
                    attributes: {
                    placeholder: "Ingrese...",
                    type: "password",
                }
                },
                    closeOnClickOutside: true,
                    button: {
                    text: "Confirmar",
                    closeModal: false,
                },
            })
            .then(password => {
                if (!password){
                    swal.close();
                }else{
                    this.$emit('enviandoStart');
                    axios.delete(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/docs',
                            {data:{password,docs:this.eliminaVarios},headers: {token:this.sessionToken}})
                        .then(res => {
                            swal.close();
                            //Se quitan los documentos de la lista
                            this.eliminaVarios.forEach(element => {
                                let index = this.docs.findIndex(x => x._id == element);
                                this.docs.splice(index,1);
                            });
                            this.eliminaVarios = [];
                            this.$emit('enviandoStop');
                        })
                        .catch(error => {
                            //console.log(error);
                            this.$emit('enviandoStop');
                            swal("Error",'Contraseña incorrecta', "error");
                        });
                }
            });
        },

        descargarVarios(){
            this.$emit('enviandoStart');
            axios({
                url: this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/docs/download',
                method: 'POST',
                responseType: 'blob', // important
                data: {docs:this.eliminaVarios},
                headers:{token:this.sessionToken}
                })
                .then(res => {
                    //this.docs.splice(index,1);
                    // console.log(res);
                    let blob = new Blob([res.data], { type: 'application/zip' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'Documentos.zip'
                    link.click()
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: 'Documentos generados correctamente' });
                })
                .catch(error => {
                    //console.log(error.response);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudieron guardar los cambios' });
                });
        },

        moverDocumento(){
            let docsIds = [];
            this.docs.forEach(element => {
                docsIds.push(element._id);
            });

            docsIds = docsIds.toString();
            //console.log(docsIds);

            this.$emit('enviandoStart');
            axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/moverDocs',
                    {docs:docsIds},
                    {headers: {token:this.sessionToken}})
                .then(res => {
                    //this.docs.splice(index,1);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: 'Cambios guardados correctamente' });
                })
                .catch(error => {
                    //console.log(error.response);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudieron guardar los cambios' });
                });
            //console.log(docsIds);
        },

        // previewDocument(index){
        //     this.preview.title = this.docs[index].nombre;
        //     this.preview.document = 'https://docs.google.com/viewer?url='+this.httpURL+'/'+this.docs[index].path+'&embedded=true';
        //     this.$refs.modalPrev.show();
        // },
        getTamanio(size){
            let tam = Math.round((size / 1000));
            if( tam < 1000) 
                return tam+" Kb";
            else{
                tam = Math.round((tam / 1000));
                return tam+" Mb";
            }
        },
        getIcon(path){
            let icon = 'lupa.png';
            let ext = path.split('.');
            switch(ext[1]){
                case 'pdf':
                    icon = 'pdf-icon.png';
                    break;
                case 'doc':
                    icon = 'txt-icon.png';
                    break;
                case 'docx':
                    icon = 'txt-icon.png';
                    break;
                case 'txt':
                    icon = 'txt-icon.png';
                    break;
                case 'xls':
                    icon = 'pdf-icon.png';
                    break;
                case 'xlsx':
                    icon = 'calculo-icon.png';
                    break;

            }
            return icon;
        },
        getFecha(fecha){
            date.locale('es');
            return date.format(new Date(fecha),'D/MMMM/YYYY');
        },
        copiarRuta(doc){
            this.copyPath = 'https://elsalto.gob.mx/portal-api/'+ doc;
            this.$refs.copyzone.value = this.copyPath;
            let testingCodeToCopy = document.querySelector('#copyzone');
            testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
            testingCodeToCopy.select()

            try {
                var successful = document.execCommand('copy');
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: 'Ruta copada a portapapeles.' });
            } catch (err) {
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo copiar la ruta.' });
            }

            /* unselect the range */
            testingCodeToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        cambiaVisible(id){
            this.enviando = true;
            axios.put(this.httpURL+'/transparencia/normatividad/documento/'+this.id+'/'+id+'/visible',
                    {},
                    {headers: {token:this.sessionToken}})
                .then(res => {
                    //this.docs.splice(index,1);
                    //this.enviando = false;
                    if( res.data.ok ){
                        this.$emit('documentoVisible',{id,visible: res.data.visible});
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: 'Cambios guardados correctamente' });
                    }
                })
                .catch(error => {
                   // console.log(error.response);
                    //this.enviando = false;
                    if(error.response){
                        this.error = error.response.data.mensaje;
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                    }
                });

            },
    }
}
</script>

<style scoped>
    .dropzone {
        min-height: 200px;
        padding: 2px 2px;
        position: relative;
        cursor: pointer;
        outline: 2px dashed grey;
        outline-offset: -10px;
        background: lightgray;
        color: dimgray;
    }

    .dropzone p {
        font-size: 1.2rem;
        text-align: center;
        padding: 70px;
    }

    .input-file {
        opacity: 0;
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropzone:hover {
        background: lightblue;
    }
</style>